var _regeneratorRuntime = require("/codebuild/output/src2133325786/src/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/codebuild/output/src2133325786/src/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require("./handlers/DM"),
    DM_Handler = _require.DM_Handler;

var _require2 = require("./handlers/ASC"),
    ASC_Handler = _require2.ASC_Handler,
    AddASCClickableHandlers = _require2.AddASCClickableHandlers,
    AddASCNavHandlers = _require2.AddASCNavHandlers,
    AddASCClickToCallHandlers = _require2.AddASCClickToCallHandlers;

var _require3 = require("./handlers/Incubeta"),
    Incubeta_Handler = _require3.Incubeta_Handler,
    AddIncubetaNavHandlers = _require3.AddIncubetaNavHandlers,
    AddIncubetaClickableHandlers = _require3.AddIncubetaClickableHandlers;

var _require4 = require("./handlers/Motorrad"),
    Motorrad_Handler = _require4.Motorrad_Handler,
    SDBSession = _require4.SDBSession;

var _require5 = require("./handlers/GoogleTag"),
    GoogleTag_Handler = _require5.GoogleTag_Handler;

var _require6 = require("./handlers/Maserati"),
    Maserati_Handler = _require6.Maserati_Handler,
    MaseratiSDBSession = _require6.MaseratiSDBSession;
/**
 * Capture events and process them
 * @param {object} data - Event data to be processed.
 * @param {object} options - Custom configuration for data processing.
 * @returns {string} Success or failure message of data processing.
 */


function captureEvent(data, options) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
      var response, handlers, i, handler;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (!(typeof window !== 'undefined')) {
                _context.next = 28;
                break;
              }

              // Check if data is empty
              if (data.length === 0) {
                reject('Cannot capture event, data object is empty.');
              } // Initialize response


              response = []; // Check if options and handlers exist

              if (!(options && options.handlers)) {
                _context.next = 23;
                break;
              }

              // Get handlers from options
              handlers = options.handlers || []; // Loop through handlers

              i = 0;

            case 7:
              if (!(i < handlers.length)) {
                _context.next = 23;
                break;
              }

              handler = handlers[i]; // Process data based on handler

              _context.t0 = handler;
              _context.next = _context.t0 === 'ASC' ? 12 : _context.t0 === 'Incubeta' ? 14 : _context.t0 === 'Motorrad' ? 16 : _context.t0 === 'Maserati' ? 18 : 20;
              break;

            case 12:
              response.push(ASC_Handler(data, options));
              return _context.abrupt("break", 20);

            case 14:
              response.push(Incubeta_Handler(data, options));
              return _context.abrupt("break", 20);

            case 16:
              response.push(Motorrad_Handler(data, options));
              return _context.abrupt("break", 20);

            case 18:
              response.push(Maserati_Handler(data, options));
              return _context.abrupt("break", 20);

            case 20:
              i++;
              _context.next = 7;
              break;

            case 23:
              // Check if gtag exists and process data with gtag
              if (window.gtag) {
                response.push(GoogleTag_Handler(data, options));
              } else {
                response.push({
                  status: 'error',
                  message: 'GoogleTag Handler failed to capture event. Error: gtag is not defined',
                  data: data
                });
              } // Process data with DM handler by default


              response.push(DM_Handler(data, options)); // Resolve response

              resolve(response);
              _context.next = 29;
              break;

            case 28:
              reject('Cannot capture event, Window is not defined.');

            case 29:
              _context.next = 34;
              break;

            case 31:
              _context.prev = 31;
              _context.t1 = _context["catch"](0);
              reject(_context.t1);

            case 34:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 31]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}
/**
 * Store events in local storage for later processing.
 * @param {object} data - Event data to be processed.
 * @param {object} options - Custom configuration for data processing.
 * @returns {string} Success or failure message of data processing.
 */


function storeEvent(data, options) {
  return new Promise( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
      var captureEvents;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              try {
                captureEvents = JSON.parse(localStorage.getItem('captureEvents')) || [];
                captureEvents.push({
                  data: data,
                  options: options
                });
                localStorage.setItem('captureEvents', JSON.stringify(captureEvents));
                resolve('Event stored successfully');
              } catch (err) {
                reject(err);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
}
/**
 * Process stored events in local storage.
 * @returns {string} Success or failure message of data processing.
 */


function processStoredEvents() {
  // Processes stored events
  return new Promise( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve, reject) {
      var captureEvents;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              try {
                captureEvents = JSON.parse(localStorage.getItem('captureEvents')) || [];

                if (captureEvents.length > 0) {
                  captureEvents.forEach(function (event) {
                    captureEvent(event.data, event.options).then(function (response) {
                      console.log(response);
                    }).catch(function (error) {
                      console.log(error);
                    });
                  });
                  localStorage.removeItem('captureEvents');
                }

                resolve('Stored events processed successfully');
              } catch (err) {
                reject(err);
              }

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }());
}
/**
 * Expose captureEvent to window for client-side Javascript access.
 * @returns {void}
 */


function exposeCaptureEvent() {
  // Expose captureEvent function to global scope
  window.captureEvent = captureEvent;
}

module.exports = {
  captureEvent: captureEvent,
  storeEvent: storeEvent,
  processStoredEvents: processStoredEvents,
  exposeCaptureEvent: exposeCaptureEvent,
  AddIncubetaNavHandlers: AddIncubetaNavHandlers,
  AddIncubetaClickableHandlers: AddIncubetaClickableHandlers,
  AddASCNavHandlers: AddASCNavHandlers,
  AddASCClickableHandlers: AddASCClickableHandlers,
  AddASCClickToCallHandlers: AddASCClickToCallHandlers,
  SDBSession: SDBSession,
  MaseratiSDBSession: MaseratiSDBSession
};